var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "grid-container",
      class: { "edit-mode": _vm.state.editMode },
      style: _vm.style,
      on: {
        mousemove: function ($event) {
          return _vm.onMouseMove($event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }